var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.55,
    stroke: "#1C738E",
    strokeWidth: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90332 3.40039C8.97525 3.40039 9.84461 4.26892 9.84473 5.34082C9.84473 6.41282 8.97532 7.28223 7.90332 7.28223C6.83142 7.28211 5.96289 6.41275 5.96289 5.34082C5.963 4.26899 6.83149 3.4005 7.90332 3.40039Z",
    stroke: "#1C738E",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 12.3643C12.0059 11.8394 11.9069 11.3186 11.7087 10.832C11.5104 10.3454 11.2168 9.90261 10.8447 9.52934C10.4727 9.15607 10.0297 8.85973 9.54142 8.65747C9.05311 8.45522 8.52918 8.35107 8 8.35107C7.47082 8.35107 6.94689 8.45522 6.45858 8.65747C5.97027 8.85973 5.52727 9.15607 5.15525 9.52934C4.78324 9.90261 4.48959 10.3454 4.29134 10.832C4.09308 11.3186 3.99414 11.8394 4.00027 12.3643",
    stroke: "#1C738E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73438 11.1936L9.07541 11.1936",
    stroke: "#1C738E",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiry);
export default __webpack_public_path__ + "static/media/enquiry.d852c571d7f729fa985aa3b1b1b34f0e.svg";
export { ForwardRef as ReactComponent };